import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/login/login').then((m) => m.LoginPage) },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', loadComponent: () => import('./pages/home/home').then((m) => m.HomePage) },
      { path: 'companies/:id', loadComponent: () => import('./pages/company/company').then((m) => m.CompanyPage) },
      { path: 'users', loadComponent: () => import('./pages/users/users').then((m) => m.UsersPage) },
      { path: 'empresas/:id', redirectTo: 'companies/:id' },
    ],
  },
  { path: '**', redirectTo: '' },
];
